import React from "react";
import { observer, inject } from "mobx-react";
import { observable, computed } from 'mobx';

@inject("store")
@observer
export default class SpreadsheetImport extends React.Component {
    // Tabular import fields
    @observable importVisible = false;
    @observable importTextArea = "Klistra in här...";
    @observable importRunButtonText = { text: "Fortsätt", visible: false, disabled: true };
    @observable importData = {
        hasHeaders: false,
        columns: [],
        rows: [],
        ready: false,
        verified: false
    }

    @observable importResultStatusFilter = "all";
    @observable importResult = [];
    @observable importResultFilters = {};

    @computed
    get importDataValid() {
        const result = this.importData &&
            this.importData.columns &&
            this.importData.columns.filter(x => x.ColumnType === "sku").length === 1 &&
            this.importData.columns.filter(x => x.ColumnType === "quantity").length === 1;


        return result;
    }

    constructor(props) {
        super(props);

        this.handlePaste = this.handlePaste.bind(this);
        this.prepareImport = this.prepareImport.bind(this);
        this.toggleImport = this.toggleImport.bind(this);
        this.runImport = this.runImport.bind(this);
    }

    handlePaste(event) {
        //console.log(event.clipboardData);
        event.clipboardData.items[0].getAsString(text => { this.prepareImport(text) });
    }

    async prepareImport(text) {

        //console.log(text);

        const articleNumberNames = ['sku', 'artnr', 'article', 'articlenumber', 'article number', 'art', 'art nr', 'art'];
        const quantityNames = ['quantity', 'q', 'orderquantity'];
        this.importData = {
            hasHeaders: false,
            columns: [],
            rows: [],
            columnTypes: [
                { Name: "Artikel nr.", Value: "sku" },
                { Name: "Antal", Value: "quantity" },
                { Name: "[Hoppa över]", Value: "" }
            ],
            ready: false,
            verified: false
        };
        var rows = text.split('\n');
        if (rows[rows.length-1] === "") {
            rows.pop(); }

        
        if (rows.length > 1000) {
            alert("Du importerar för många rader. Max 1000");
            this.importTextArea = "";
            return;
        }

        for (var rI = 0; rI < rows.length; rI++) {
            if (rows[rI].trim() === "") continue;
            var cols = rows[rI].split('\t');
            var newRow = [];
            for (var cI = 0; cI < cols.length; cI++) {
                newRow[cI] = cols[cI].trim();
                if (this.importData.columns.length <= cI) { this.importData.columns.push({ index: cI, ColumnType: "", Locked: false }) };
            }

            this.importData.rows.push(newRow);
        }
        //console.log(this.importData.columns);
        //console.log(this.importData.row);


        // 1. Check first row for column names 

        for (var frI = 0; frI < this.importData.columns.length; frI++) {

            if (articleNumberNames.indexOf(this.importData.rows[0][frI].toLowerCase()) > -1) {
                this.importData.columns[frI].ColumnType = "sku";
                this.importData.hasHeaders = true;
                this.importData.columns[frI].Locked = true;
            }

            if (quantityNames.indexOf(this.importData.rows[0][frI].toLowerCase()) > -1) {
                this.importData.columns[frI].ColumnType = "quantity";
                this.importData.hasHeaders = true;
                this.importData.columns[frI].Locked = true;
            }
        }

        if (this.importData.hasHeaders) {
            for (var hI = 0; hI < this.importData.columns.length; hI++) {
                this.importData.columns[hI].ColumnName = this.importData.rows[0][hI];
            }

        }

        // 3. Try to find quantities (number), sanity checks. no negatives, max 9999?

        if (!this.importData.columns.find(x => x.ColumntType === "quantity")) {
            var quantityRegex = /^(?!-)\d{1,4}$/;
            var quantityNumberRegex = /^[0-9]+([,.][0-9]+)?$/;
            for (var iq = 0; iq < this.importData.columns.length; iq++) {
                if (!this.importData.columns[iq].ColumnType === "") { continue; }
                var quantityMatch = this.checkColumnRegex(this.importData, this.importData.columns[iq], quantityRegex, 10);
                var quantityNumberMatch = this.checkColumnRegex(this.importData, this.importData.columns[iq], quantityNumberRegex, 10);
                if (quantityMatch && quantityNumberMatch) {
                    this.importData.columns[iq].ColumnType = "quantity";
                }
            }
        }


        // 2. Try to find article numbers (string without whitespace)

        if (!this.importData.columns.find(x => x.ColumnType === "sku")) {
            var skuRegexp = /^\S+$/;
            var numberRegex = /^[0-9]+([,.][0-9]+)?$/;
            for (var i = 0; i < this.importData.columns.length; i++) {
                if (this.importData.columns[i].ColumnType !== "") {
                    continue;
                }
                //todo: not empty
                var skuMatch = this.checkColumnRegex(this.importData, this.importData.columns[i], skuRegexp, 10);

                //var numberMatch = this.checkColumnRegex(this.importData, this.importData.columns[i], numberRegex, 10);

                if (skuMatch) {
                    this.importData.columns[i].ColumnType = "sku";
                }
            }
        }


        // 3.1 If multiple sku-results, send a few to the server to see if the data is an article number
        if (this.importData.columns.filter(col => col.ColumnType === "sku").length > 1) {
            var columns = this.importData.columns.filter(col => col.ColumnType === "sku");

            for (var oSku in columns) {

                if (columns.hasOwnProperty(oSku)) {
                    const col = columns[oSku];
                    // check a few items 
                    col.ColumnType = "";
                    console.log("loop:", col.ColumnType);
                    this.checkIsValidSku(this.importData, col, 2).then(res => {

                        console.log("valid sku 1: ", res, col.index);
                        if (res) {
                            console.log("valid sku: ", res);
                            col.ColumnType = "sku";
                        }
                    });

                }
            }
        }

        // 3.1 If multiple quantities, guess by lowest column sum
        if (this.importData.columns.filter(col => col.ColumnType === "quantity").length > 1) {
            const qCol = this.importData.columns.filter(col => col.ColumnType === "quantity");

            for (var o in qCol) {
                if (qCol.hasOwnProperty(o)) {
                    const col = qCol[o];

                    // check a few items 
                    //col.ColumnType = ""; // reset type for chose columns
                    let colSum = 0;
                    for (i = 0; i < this.importData.rows.length; i++) {
                        colSum += parseInt(this.importData.rows[i][col.index]);
                    }
                    col.Sum = colSum;
                }
            };

            // todo:finish this
        }

        this.importData.ready = true;
        this.importRunButtonText = { text: "Fortsätt", disabled: false, visible: true };
    }


    toggleImport() {
        this.importRunButtonText = { text: "Fortsätt", visible: false, disabled: true };
        this.importData = {};
        this.importResult = [];
        this.importVisible = !this.importVisible;
    }

    runImport() {
        this.importRunButtonText = {
            text: this.importData.verified
                ? "* Vänligen vänta, lägger till produkter på ordern *"
                : "* Verifierar data... *", disabled: true, visible: true
        };
        const skuColumn = this.importData.columns.find(col => col.ColumnType === "sku");
        const quantityColumn = this.importData.columns.find(col => col.ColumnType === "quantity");
        

        
        const changes = [];
        for (var i = (this.importData.hasHeaders ? 1 : 0); i < this.importData.rows.length; i++) {
            const change = {
                OrderLineId: -1,
                Sku: this.importData.rows[i][skuColumn.index],
                VariantSku: null,
                //VariantSku: this.importData.rows[i][skuColumn.index],
                OriginalQuantity: this.importData.rows[i][quantityColumn.index]
            };
            if (!this.importData.verified ||
                (this.importData.verified && this.importData.rows[i].status.indexOf("Ready") > -1)) {
                changes.push(change);
            }
        }

        this.props.store.order.updateQuantities(changes, { import: true, commit: this.importData.verified }).then(res => {
            this.importResult = res;

            if (!this.importData.verified) {
                //this.importVisible = false;
                const importResultFiltersCount = [];
                for (var i = (this.importData.hasHeaders ? 1 : 0); i < this.importData.rows.length; i++) {
                    const sku = this.importData.rows[i][skuColumn.index];

                    const resultRow = res.find(x => x.VariantSku === sku || x.Sku === sku);
                    if (resultRow) {
                        this.importData.rows[i].status = resultRow.Message;

                        if (!importResultFiltersCount[resultRow.Message]) {
                            importResultFiltersCount[resultRow.Message] = 1;
                        } else {
                            importResultFiltersCount[resultRow.Message] =
                                importResultFiltersCount[resultRow.Message] + 1;
                        }

                    }
                }
                this.importResultStatusFilter = "all";
                this.importResultFilters = {};

                for (let row of res) {
                    if (!this.importResultFilters[row.Message]) {
                        this.importResultFilters[row.Message] = { Text: row.Message, Count: 0 };
                    }
                }

                for (let count in importResultFiltersCount) {
                    if (importResultFiltersCount.hasOwnProperty(count)) {
                        console.log("count", importResultFiltersCount[count]);
                        this.importResultFilters[count].Count = importResultFiltersCount[count];
                    }
                }

                console.log(this.importResultFilters);

                this.importData.verified = true;
                this.importRunButtonText = { text: "Slutför import", disabled: false, visible: true };
            } else {
                this.toggleImport();
            }


        },
            err => {
                this.importRunButtonText = { text: "Fortsätt", disabled: false, visible: true };
                alert(err.message);
            });
        //console.log("changes", changes);
    }

    async checkIsValidSku(data, column, checks) {
        let result = 0;
        for (var c = 0; c < checks; c++) {
            const checkRowIndex = Math.floor(Math.random() * (data.rows.length - (data.hasHeaders ? 1 : 0))) + (data.hasHeaders ? 1 : 0);
            const perhapsASku = this.importData.rows[checkRowIndex][column.index];

            var res = await this.props.store.order.getProduct(perhapsASku); //.then(res => {

            //console.log("checkIsValidSku", res);
            if (res && res.product) {
                // This is a valid sku
                result++;
            }
            //});
        }
        console.log("result", result, checks, result / checks);
        return (result / checks) > 0.2;

    }


    checkColumnRegex(data, column, regexp, checks) {
        let result = 0;
        for (var c = 0; c < checks; c++) {
            const checkRowIndex = Math.floor(Math.random() * (data.rows.length - (data.hasHeaders ? 1 : 0))) + (data.hasHeaders ? 1 : 0);
            const checkColumnIndex = column.index;
            if (regexp.test(data.rows[checkRowIndex][checkColumnIndex])) {
                result++;
            }
        }

        return (result / checks) > 0.75;
    }

    render() {


        return (

            <React.Fragment>
                {!this.importVisible
                    ? ""
                    : <div className="spreadsheat-import-container"

                        onPaste={(e) => { this.handlePaste(e); }} >
                        <div style={{ display: "flex", flexFlow: "column", height: "100%" }}>
                            <div style={{ flex: "0 1 auto" }}>
                                <span className="float-right"></span>
                                <div onClick={(e) => this.toggleImport()} style={{ position: "absolute", top: "8px", right: "10px", fontWeight: "bold", cursor: "pointer" }}>X</div>
                                <h6>Klistra in från Excel</h6>
                                <p>Använd Ctrl+V (Cmd+V på mac)</p>
                                <p className="">
                                    Artiklenummer och antal ska ligga i två olika kolumner. Ordningen på kolumnerna spelar ingen roll då det ges möjlighet att justera detta efter inläsningen är gjord.
                                </p>
                                <textarea style={{ width: "100%" }}
                                    autoFocus={true}
                                    value={this.importTextArea}
                                    onChange={(e) => { }}
                                    onBlur={() => { this.importTextArea = "[Klistra in här...]"; }}
                                    onFocus={() => { this.importTextArea = ""; }}
                                />

                                <div className="row">
                                    <div className="col-12">
                                        {this.importRunButtonText.visible &&
                                            <button className="btn btn-light  "
                                                onClick={(e) => this.runImport()}
                                                disabled={!this.importDataValid || this.importRunButtonText.disabled}
                                            ><i className="material-icons move_to_inbox"></i>
                                                {this.importRunButtonText.text}

                                            </button>}
                                        <button className="btn btn-light "
                                            onClick={(e) => this.toggleImport()}><i className="material-icons close"></i> Avbryt
                                            </button>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: "1 1 auto", overflow: "scroll" }} >

                                {!this.importData.ready
                                    ? ""
                                    : <table className="table table-responsive table-condensed table-sm">
                                        <thead>
                                            <tr>
                                                {!this.importData.verified
                                                    ? null :
                                                    <th key={"col-status"}
                                                        style={{
                                                        }}
                                                    >
                                                    <select
                                                            value={this.importResultStatusFilter}
                                                            onChange={(e) => { 
                                                                this.importResultStatusFilter = e.target.value
                                                            }}
                                                        >
                                                            <option key="all" value="all">All</option>

                                                            {Object.keys(this.importResultFilters).map(rfKey => {
                                                                const rf = this.importResultFilters[rfKey];
                                                                return (
                                                                    <option key={rf.Text} value={rf.Text}>{rf.Text
                                                                    } ({rf.Count})</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </th>
                                                }


                                                {this.importData.columns.map(col => (
                                                    <th key={"col" + col.index}
                                                        style={{
                                                            backgroundColor: this.importData.columns[col.index].ColumnType !==
                                                                ""
                                                                ? "#a7c04d"
                                                                : ""
                                                        }}
                                                    >
                                                        {this.importData.hasHeaders
                                                            ? <span>{col.ColumnName} <br /></span>
                                                            : ""}
                                                        {this.importData.verified ? col.ColumnType :
                                                            <select
                                                                value={col.ColumnType}
                                                                onChange={(e) => { col.ColumnType = e.target.value }}
                                                            >
                                                                {this.importData.columnTypes.map(ct => (
                                                                    <option key={ct.Value} value={ct.Value}>{ct.Name}</option>
                                                                ))}
                                                            </select>}

                                                    </th>
                                                ))}


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.importData.rows.filter(rowFilter => !this.importData.verified ||
                                                (this.importData.verified && (this.importResultStatusFilter === "all" || rowFilter.status === this.importResultStatusFilter))).map((row, index) => (
                                                    <tr key={"row" + index}>
                                                        {!this.importData.verified
                                                            ? null : <td>{row.status}</td>
                                                        }
                                                        {row.map((field, fieldIndex) => (
                                                            <React.Fragment key={"rowFragment" + fieldIndex}>
                                                                {
                                                                    this.importData.hasHeaders && index === 0
                                                                        ? null
                                                                        : <td key={"field" + fieldIndex} style={{
                                                                            backgroundColor: this.importData.columns[fieldIndex]
                                                                                .ColumnType !==
                                                                                ""
                                                                                ? "#a7c04d"
                                                                                : ""
                                                                        }}><span style={{ whiteSpace: "nowrap" }}>{field
                                                                        }</span></td>
                                                                }

                                                            </React.Fragment>
                                                        ))}


                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>}


                            </div>
                        </div>
                    </div>}
                <button
                style={{width:100, height:30}}    
                    className="btn small btn-light my-0 mr-0" title="Klistra in från kalkylblad (Excel, Spreadsheet..)"
                    onClick={(e) => this.toggleImport()
                    }><i className="material-icons content_paste"></i>&nbsp;Klistra in</button>
            </React.Fragment >
        );
    }
}